export default __webpack_public_path__ + "static/media/puppyMaleGray.0c62a0a3.jpg";